<template>
    <div v-if="$store.state.user" class="home">
        <div class="d-home" v-if="this.$store.state.user.dash_vis">
          <PageTitle main="Dashboard" sub=""/>
          <b-form-group label-for="lab-empresaId" class="select-home select-company">
              <b-form-select              
                id="combo-empresaId"    
                v-model="selected" :options="options"
                v-on:change="getSelectedItem()">
              </b-form-select>
          </b-form-group>
        </div>
        

        <div class="stats" v-if="(stat !== null)">
            <NotifCert v-if="(stat.data.fl_notif_cert)"
                title="Atenção" icon="fa fa-exclamation-triangle" color="#333" 
                :fl_notif_cert="stat.data.fl_notif_cert" :dt_valid_cert="stat.data.dt_valid_cert" :dias_expirar="stat.data.dias_expirar"/> 
        </div>
                
        <div class="stats" v-if="((stat !== null) && (this.$store.state.user.dash_vis))">
            <Stat title="Notas Pendentes" :value="stat.data.qtdnotaspendente" icon="pending" color="#007bff"/> 
            <Stat title="Em Autorização" :value="stat.data.qtdnotasemautorizacao" icon="processing" color="#6c757d"/> 
            <Stat title="Notas Rejeitadas" :value="stat.data.qtdnotasrejeitada" icon="rejected" color="#dc3545" /> 
        </div>

        <div class="stats my-3" v-if="((stat !== null) && (this.$store.state.user.dash_vis))">
            <Stat :title="'Notas Autorizadas ' + stat.data.mes" :value="stat.data.qtdnotasautorizada" icon="allowed" color="#28a745"/> 
            <Stat title="Em Cancelamento" :value="stat.data.qtdnotasemcancelamento" icon="cancelling" color="#6c757d" rotulo="Total de notas em cancelamento" /> 
            <Stat :title="'Notas Canceladas ' + stat.data.mes" :value="stat.data.qtdnotasemcancelada" icon="canceled" color="#ffc107"/> 
        </div>

        <div class="half-charts">
          <ChartBar v-if="((stat !== null) && (this.$store.state.user.dash_vis))" :titulo="'Total de notas autorizadas em ' + stat.data.ano" :rotulos="stat.graflabels" :dados="stat.grafdata" />
  
          <ChartLine v-if="((stat !== null) && (this.$store.state.user.dash_vis))" :titulo="'Quantidade de notas autorizadas em ' + stat.data.ano" :rotulos="stat.graflabels" :dados="stat.grafdataline" />
        </div>
    </div>
</template>

<script>
import { baseApiUrl, userCredential } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'
import Stat from './Stat'
import NotifCert from './NotifCert'
import ChartBar from '@/components/chart/ChartBar';
import ChartLine from '@/components/chart/ChartLine';

export default {
    name: 'Home',
    components: { PageTitle, Stat, NotifCert, ChartLine, ChartBar },
    data() {
        return {
            stat: null,  

            statCarregada: {
                status: false,
                mensagem: '',
                data: {
                    empid: 0,
                    empresa: '',
                    ano: 0,
                    mes: '',
                    qtdcliente: 0,
                    qtdnotaspendente: 0,
                    totalnotaspendente: 0,
                    qtdnotasrejeitada: 0,
                    totalnotasrejeitada: 0,
                    qtdnotasautorizada: 0,
                    totalnotasautorizada: 0,
                    fl_notif_cert: false,
                    dt_valid_cert: null,
                    dias_expirar: 0
                },
                graflabels: '',
                grafdata: '0,0,0,0,0,0,0,0,0,0,0,0',
                grafdataline: '0,0,0,0,0,0,0,0,0,0,0,0'
            },

            selected: null,  
            options: []
        }
    },
    methods: {
        getStats() {
            this.stat = null 
            axios.get(`${baseApiUrl}/dashboard/`+ this.selected)
                 .then(resp => {
                     this.stat = resp.data
            })
        },      
        
        getSelectedItem() {
            let empComboSel = document.getElementById('combo-empresaId').value;
            this.selected = empComboSel;
            this.stat = null  
            axios.get(`${baseApiUrl}/dashboard/`+ this.selected)
                 .then(resp => {
                     this.stat = resp.data
            })
        }
    },

    mounted() {
        // Resgata emp default do usuario
        if(!this.$store.state.user){
            this.$router.push({ path: '/auth' })
            return
        }
        const json = localStorage.getItem(userCredential)
        const userData = JSON.parse(json)

        this.selected = userData.empid 
        this.options  = userData.emps
        this.getStats()
    }
}
</script>

<style>
    .d-home{
        display: flex;
    }
    .stats {
        display: flex;
        gap: 20px;
        justify-content: space-between;
        flex-wrap: wrap;
    }
    .select-company {
        width: 100%;
        margin-left: 120px;
        margin-top: 25px;
    }
    .select-company select {
        border-radius: 10px !important;
        height: 50px;
        box-shadow: none !important;
    }
    .select-company select:is(:focus, :hover) {
      box-shadow: none !important;
    }
    .half-charts {
        display: grid;
        grid-template-columns: repeat(2, calc(50% - 10px));
        gap: 40px;
        margin-top: 20px;
    }
    @media (max-width: 768px) {
        .d-home{
            display: grid;
        }
        .select-home{
            margin-bottom: 1rem;
            margin-top: 0;
            margin-left: 0;
        }
    }
  
</style>